<template>
    <Base>
        <v-card-title class="text-center d-block">
            <span class="t-color-brand-medium-base">Código de autenticação</span>
        </v-card-title>
        <v-card-text>
            <div class="t-body mb-5">
                Utilize um dos códigos de recuperação para logar.<br/>
                Após utilizar um código ele será invalidado.<br/>
                No seu perfil é possível visualizar todos os códigos disponíveis.
            </div>

            <form
                :action="route('two-factor.login.store')"
                id="formLogin"
                method="post"
            >
                <cp-csrf-token/>

                <v-text-field
                    label="Código de recuperação"
                    name="recovery_code"
                    outlined
                    dense
                    required
                ></v-text-field>

                <div class="d-flex justify-end mt-3">
                    <cp-button
                        color="primary"
                        type="submit"
                        :disabled="saving"
                        :loading="saving"
                        @click="submit"
                    >
                        Acessar
                    </cp-button>
                </div>
            </form>
        </v-card-text>
        <v-card-actions class="d-block text-right">
            <v-divider></v-divider>
            <a :href="route('two-factor.login')" class="t-hint">Acessar com código do aplicativo</a>
        </v-card-actions>
    </Base>
</template>

<script>
import Base from '@components/common/Base'

export default {
    data: () => ({
        saving: false,
        otp: null,
        type: null
    }),

    metaInfo: () => ({
        title: 'Login com Código de Recuperação'
    }),

    components: {
        Base
    },

    methods: {
        submit () {
            this.saving = true
            setTimeout(() => { document.querySelector('#formLogin').submit() }, 1000);
        },
    },
}
</script>